// extracted by mini-css-extract-plugin
export default {"post":"Post_post__Tw4kf","divs":"Post_divs__y6Biy"};